<template>
  <component
    :is="variant === 'table' ? 'tr' : 'div'"
    class="grid-show-all"
    :class="{ 'text-center': variant === 'card' }"
    @click="emit('show-all')"
  >
    <td v-if="variant === 'table'" class="text-center" :colspan="colspan">
      <a class="bm-link">{{ linkText }}</a>
    </td>
    <a v-else class="bm-link">{{ linkText }}</a>
  </component>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { translateWithParams } from "@/plugins/i18n";

interface BmGridShowAllRowsProps {
  remainingRows: number;
  variant?: "table" | "card";
  colspan?: number;
}

const props = withDefaults(defineProps<BmGridShowAllRowsProps>(), {
  variant: "table",
  colspan: 1,
});

interface BmGridShowAllRowsEvents {
  (event: "show-all"): void;
}

const emit = defineEmits<BmGridShowAllRowsEvents>();

const linkText = computed(() =>
  translateWithParams("show_all_rows", {
    remainingRows: props.remainingRows.toString(),
  })
);
</script>

<style scoped lang="sass">
.grid-show-all
  height: 40px !important

.grid-show-all td
  border-bottom-style: none
</style>
